import { forwardRef } from 'react';
// Ui
import Text from 'ui3/Text/Text';
import Switch from 'ui3/Switch/Switch';
// Styles
import styles from './ToggleSection.module.scss';

type ToggleSectionProps = {
  /** Leave out for a section that is always on. */
  name?: string;
  /** Shows the switch locked off. */
  disabled?: boolean;
  title: string;
  description: string;
  children?: React.ReactNode;
};

const ToggleSection = forwardRef<HTMLInputElement, ToggleSectionProps>(
  ({ name, disabled, title, description, children }, ref) => (
    <div className={styles.root}>
      <div className={styles.header}>
        <div className={styles.copy}>
          <Text variant="body1Medium16">{title}</Text>
          <Text variant="body2Regular" color="lights-low">
            {description}
          </Text>
        </div>
        {name && (
          <Switch
            name={name}
            ref={ref}
            disabled={disabled}
            wrapperClassName={styles.switch}
          />
        )}
      </div>
      {children}
    </div>
  )
);

ToggleSection.displayName = 'ToggleSection';

export default ToggleSection;
